(function() {
  'use strict';

  angular
    .module('newDocument.errorService', [])
    .factory('newDocumentErrorService', newDocumentErrorService);

  newDocumentErrorService.$inject = ['$modal', 'Navigation', 'SpinnerHelper'];

  function newDocumentErrorService($modal, Navigation, SpinnerHelper) {
    var instance;

    return {
      showError: showError
    };

    function showError(scope) {
      // only 1 error at a time
      if (instance) {
        scope.$destroy();
        return;
      }

      Navigation.state = Navigation.states.ready;
      SpinnerHelper.hideAllSpinners();

      instance = $modal.open({
        templateUrl: 'contentPlayer/contentErrorModal.html',
        controller: 'ContentErrorModal',
        scope: scope,
        backdrop: 'static'
      });

      scope.$on('$destroy', function() {
        instance = null;
      });
    }
  }
})();
